import { DependencyList, EffectCallback, useLayoutEffect } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { PlayerAdapter } from '../types/instance';

export const useInstanceLayoutEffect = (
    callback: (instance: PlayerAdapter) => ReturnType<EffectCallback>,
    deps: DependencyList = []
) => {
    const instance = usePlayerInstance();

    // eslint-disable-next-line consistent-return
    useLayoutEffect(() => {
        if (instance) {
            return callback(instance);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance, ...deps]);
};
